type Accent = 'primary' | 'accent' | 'secondary';

interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  accent?: Accent;
  action?: { label: string; href: string };
}

const accentBar: Record<Accent, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

const accentText: Record<Accent, string> = {
  primary: 'text-primary-700',
  accent: 'text-accent-700',
  secondary: 'text-secondary-700',
};

export default function SectionHeading({
  kicker,
  title,
  desc,
  accent = 'primary',
  action,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        <div className="mb-2 flex items-center gap-2">
          <span className={`h-4 w-1 rounded-full ${accentBar[accent]}`}></span>
          <span className={`text-xs font-medium tracking-[0.2em] ${accentText[accent]}`}>
            {kicker}
          </span>
        </div>
        <h2 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc ? (
          <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>
        ) : null}
      </div>
      {action ? (
        <a
          href={action.href}
          className="inline-flex shrink-0 cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          {action.label}
          <i className="ri-arrow-right-s-line"></i>
        </a>
      ) : null}
    </div>
  );
}